import React from 'react'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import AboutPage from '../src/components/pages/BrandPages/About'
import { getTrustPilotRating } from 'src/common/getTrustPilotRating'
import { aboutUsContent } from 'src/components/pages/BrandPages/About/consts'
import { getMegamenuData } from 'src/common/back/megamenu'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'

export async function getServerSideProps(context) {
  const jsonLdSchemas = await getContentfulJsonLd('about/')
  let megamenuData = null
  let trustMarker = {
    ratingValue:
      aboutUsContent?.jsonLdData?.publisher?.aggregateRating?.ratingValue,
    ratingCount:
      aboutUsContent?.jsonLdData?.publisher?.aggregateRating?.ratingCount,
    reviewCount:
      aboutUsContent?.jsonLdData?.publisher?.aggregateRating?.reviewCount,
  }
  try {
    trustMarker = await getTrustPilotRating(context?.preview, trustMarker)

    megamenuData = await getMegamenuData(context)
  } catch (error) {
    return {
      props: {
        trustMarker,
        megamenuData: null,
        jsonLdSchemas,
      },
    }
  }

  return {
    props: {
      trustMarker,
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

const About = ({ megamenuData, jsonLdSchemas }) => (
  <>
    <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
    <Layout isBrandPage={true} megamenuData={megamenuData}>
      <AboutPage />
    </Layout>
  </>
)

export default About
